export default __webpack_public_path__ + "static/media/NRG_ΦΑ.42837500.png";